import { createFileRoute } from '@tanstack/react-router';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ensureVirtualTourByIdQueryData } from '@/features/estate-media/api/virtual-tour';

export const Route = createFileRoute(
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/'
)({
  component: RouteComponent,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="360Virtual-tours" /> },
});

function RouteComponent() {
  return ensureVirtualTourByIdQueryData;
}
